// Antes el "800" que separa el layout mobile del desktop estaba repetido
// como número mágico en CoNav, CoWorkCard y CoWorkList, sin ninguna garantía
// de que se mantuvieran sincronizados si alguno cambiaba.
export const MOBILE_BREAKPOINT = 800;
